module.exports = __webpack_public_path__ + "static/img/b202.de4443db.png";